import React, { useContext, useEffect, useState } from 'react';
import styled from "styled-components";
import { AppContext } from '../../contexts/AppContext';
import { CardRow } from './CardRow';
import { Cell } from './Cell';
import { TitleCell } from './TitleCell';

const Wrapper = styled.div`
display: flex;
flex-direction: column;
height: 100%;
width: 100%;
margin: 12px;
margin-top: 0px;
`;

const HeaderCard = styled.div`
background-color: ${props => props.colorTheme.backgroundColor};
display:  flex;
flex-direction: row;
overflow-x: hidden;
overflow-y: hidden;
width: 100%;
border-radius: 5px;
min-height: 29px;
`;

export function CardList({ orders }) {

    const { currentTheme } = useContext(AppContext);

    return (
        <Wrapper >
            <HeaderCard colorTheme={currentTheme.dashboard}>

                <TitleCell text={"Created At"} />
                <TitleCell text={"Order #"} />
                <TitleCell text={"Order Source"} />
                <TitleCell text={"Brand"} />
                <TitleCell text={"Status"} />
                <TitleCell text={"Delivery Status"} />

            </HeaderCard>

            {
                orders.map((order, i) => (
                    <CardRow key={i} order={order} />
                ))
            }
        </Wrapper>
    );
}